<template>
  <div>
    <my-head></my-head>
    <div class="enterprisecertification minH">
      <div class="title">企业认证列表</div>
      <enterprise-list ref="child"></enterprise-list>
    </div>
    <my-footer></my-footer>
  </div>
</template>

<script>
import MyHead from "../components/MyHead.vue";
import MyFooter from "../components/MyFooter.vue";
import EnterpriseList from "../components/EnterpriseList.vue";
export default {
  name: "enterprisecertification",
  components: {
    MyHead,
    MyFooter,
    EnterpriseList,
  },
  mounted() {
    if (this.$route.params.tanchu) {
      this.$refs.child.openEdit();
    }
  },
};
</script>

<style lang="scss">
.enterprisecertification {
  width: 80%;
  margin: 24px auto 60px;
  .title {
    font-size: 24px;
    font-weight: bold;
    color: #1d2129;
    line-height: 32px;
    margin-bottom: 24px;
  }
}
</style>
